export default function (t) {
	return {
		projects: [...Array(19).keys()].map((idx) => {
			idx = idx + 1;
			return t("project_" + idx)
		})
	}
}